import React, { useEffect, useState } from 'react';
import Header from './Header.js';
import HeroSection from './HeroSection.js';
import ProductShowcase from './ProductShowcase.js';
import WhySection from './WhySection.js';
import Footer from './Footer.js';
import NewsletterSubscription from './NewsletterSubscription.js';
import FloatingHexagonBackground from './FloatingHexagonBackground.js';

const AutomotiveProtectionPage = () => {
  const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' ? window.innerWidth < 768 : false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Background parallax/animation now handled by FloatingHexagonBackground

  return (
    <div className="font-bai-jamjuree text-gray-800 bg-white">
      <Header />
      <HeroSection />
      {/* Shared background wrapper for Why + Products */}
      <div className="relative z-0 min-h-screen overflow-visible">
        {!isMobile && (
          <div className="absolute inset-0 z-0">
            <FloatingHexagonBackground />
          </div>
        )}
        <div className="relative z-20">
          <WhySection />
          <ProductShowcase suppressBackgroundEffects />
        </div>
      </div>
      
      <NewsletterSubscription />
      
      <Footer />
    </div>
  );
};

export default AutomotiveProtectionPage;
